import React, { useState } from 'react';
import './IICPage.css';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

const IICPage = () => {
  const [activeTab, setActiveTab] = useState('internal');

  const memberData = {
    internal: [
      ["1", "Prof. Sonu Gupta", "Deputy Director, TIMSCDR", "HOI, TIMSCDR"],
      ["2", "Ms. Thara Chakkingal", "Assistant Professor", "President, IIC"],
      ["3", "Dr. Sonal Sharma", "Associate Professor", "Convener, IIC"],
      ["4", "Dr. Padma Mishra", "Associate Professor", "Coordinator – IPR"],
      ["5", "Dr. Ashwini Renavikar", "Professor", "Innovation"],
      ["6", "Mr. Brijesh Pandey", "Assistant Professor", "Internship"],
      ["7", "Ms. Rupali Jadhav", "Assistant Professor", "NIRF"],
      ["8", "Ms. Kinjal Doshi", "Assistant Professor", "Social Media"],
      ["9", "Ms. Shweta Waghmare", "Assistant Professor", "Start-Up"]
    ],
    external: [
      ["10", "Dr. Suresh Shan", "External Expert", "Member"],
      ["11", "Mr. Vishal Sanghvi", "External Expert", "Member"]
    ]
  };

  const handleDownload = (year) => {
    const filePath = `/RD/rating-${year}.jpg`;
    const link = document.createElement('a');
    link.href = filePath;
    link.download = `IIC_Rating_Certificate_${year}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Navbar />
      <div className="lib-dash-container">

        <PageHeader
          title="Institution Innovation Council (IIC)"
          crumbs={[{ label: "Home", href: "/" }, { label: "Institution Innovation Council (IIC)" }]}
        />

        {/* About Section */}
        <div id="about" className="tims-section-about">
          <div className="tims-content-width tims-about-padding-top">
            <div className="tims-section-title">About IIC at TIMSCDR</div>
            <div className="tims-about-text">
              <div className="tims-p">
                TIMSCDR, recognized as the best institute for MCA, has established IIC in the Academic Year 2018-2019.
              </div>
              <div className="tims-p">
                In the year 2019, the Ministry of Education (MoE) through MoE's Innovation Cell (MIC) launched the Institution's Innovation Council (IIC) program in collaboration with AICTE for Higher Educational Institutions (HEIs) to systematically foster the culture of innovation and start-up ecosystem in education institutions.
              </div>
              <div className="tims-p">
                Primarily, IIC's role is to engage large number of faculty, students and staff in various innovation and entrepreneurship related activities such as ideation, Problem solving, Proof of Concept development, Design Thinking, IPR, project handling and management at Pre-incubation/Incubation stage, etc., so that innovation and entrepreneurship ecosystem gets established and stabilized in HEIs.
              </div>
            </div>
          </div>
        </div>

        {/* Focus and Functions */}

<div className="tims-grid-section">
  <div className="tims-content-width tims-two-col">

    {/* COLUMN 1: Major Focus of IIC */}
    <div className="tims-focus-col">
      <h2 className="tims-sub-heading">Major Focus of IIC</h2>
      <div className="tims-feature-list">

        {/* Focus Item 1 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <circle cx="12" cy="12" r="3"></circle>
              <line x1="12" y1="2" x2="12" y2="4"></line><line x1="12" y1="20" x2="12" y2="22"></line>
              <line x1="4.93" y1="4.93" x2="6.34" y2="6.34"></line><line x1="17.66" y1="17.66" x2="19.07" y2="19.07"></line>
              <line x1="2" y1="12" x2="4" y2="12"></line><line x1="20" y1="12" x2="22" y2="12"></line>
              <line x1="4.93" y1="19.07" x2="6.34" y2="17.66"></line><line x1="17.66" y1="6.34" x2="19.07" y2="4.93"></line>
            </svg>
          </div>
          <div className="tims-feature-text">
            <h4 className="tims-h4">Vibrant Local Ecosystem</h4>
            <p className="tims-p">To create a vibrant local innovation ecosystem</p>
          </div>
        </div>

        {/* Focus Item 2 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
              <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
              <path d="M9 12H4s.55-3.03 2-5c1.62-2.2 5-3 5-3"></path>
              <path d="M12 15v5s3.03-.55 5-2c2.2-1.62 3-5 3-5"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            <h4 className="tims-h4">Mechanism Support</h4>
            <p className="tims-p">Start-up/ entrepreneurship supporting Mechanism in HEIs</p>
          </div>
        </div>

        {/* Focus Item 3 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </div>
          <div className="tims-feature-text">
            <h4 className="tims-h4">Scouting Ideas</h4>
            <p className="tims-p">Establish Function Ecosystem for Scouting Ideas and Pre-incubation of Ideas</p>
          </div>
        </div>

        {/* Focus Item 4 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 4.44-2.54Z"></path>
              <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-4.44-2.54Z"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            <h4 className="tims-h4">Cognitive Ability</h4>
            <p className="tims-p">Develop better Cognitive Ability amongst Technology Students</p>
          </div>
        </div>
      </div>
    </div> {/* End Major Focus Card */}

    {/* COLUMN 2: Functions of IIC */}
    <div className="tims-functions-col">
      <h2 className="tims-sub-heading">Functions of IIC</h2>
      <div className="tims-feature-list">

        {/* Function Item 1 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <path d="M9 18h6"></path><path d="M10 22h4"></path>
              <path d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7Z"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            {/* Functions items have no titles, so only tims-p is used */}
            <p className="tims-p">Promote innovation in the Institution through multitudinous modes leading to an innovation promotion eco-system in the campus</p>
          </div>
        </div>

        {/* Function Item 2 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line><path d="m9 16 2 2 4-4"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            <p className="tims-p">To conduct various innovation and entrepreneurship-related activities prescribed by Central MIC in time bounded fashion.</p>
          </div>
        </div>

        {/* Function Item 3 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
              <path d="M4 22h16"></path>
              <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
              <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            <p className="tims-p">Identify and reward innovations and share success stories.</p>
          </div>
        </div>

        {/* Function Item 4 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
              <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            <p className="tims-p">Organize periodic workshops/ seminars/ interactions with entrepreneurs, investors, professionals and create a mentor pool for student innovators.</p>
          </div>
        </div>

        {/* Function Item 5 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            <p className="tims-p">Network with peers and national entrepreneurship development organizations.</p>
          </div>
        </div>

        {/* Function Item 6 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <rect x="2" y="3" width="20" height="14" rx="2"></rect>
              <path d="M8 21h8m-4-4v4"></path>
            </svg>
          </div>
          <div className="tims-feature-text">
            <p className="tims-p">Create an Institution's Innovation portal to highlight innovative projects carried out by institution's faculty and students.</p>
          </div>
        </div>

        {/* Function Item 7 */}
        <div className="tims-feature-item">
          <div className="tims-icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="tims-svg-icon">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
          </div>
          <div className="tims-feature-text">
            <p className="tims-p">Organize Hackathons, idea competition, mini-challenges etc., with the involvement of industries.</p>
          </div>
        </div>

      </div>
    </div> {/* End Functions Card */}
  </div> {/* End Two Col Grid */}
</div>

        {/* Objective Section */}
        <div className="tims-grid-section-objective">
          <div className="tims-content-width">
            <div className="tims-section-title">Objective / Role</div>
            <div className="tims-objective-text-container">
              <div className="tims-p">
                Engage faculty members and students in various innovation and entrepreneurship related activities such as Ideation, Problem Solving, Proof of Concept Development, Design Thinking, IPR, Project Handling and Management.
              </div>
              <div className="tims-p">
                Organize periodic workshops/ seminars/ interactions with entrepreneurs, investors, professionals and create a mentor pool for student innovators.
              </div>
            </div>
          </div>
        </div>

        {/* Members Section */}
        <div id="members" className="tims-section-members">
          <div className="tims-content-width tims-members-width-reducer">
            <div className="tims-section-title-alt">IIC COUNCIL MEMBERS AT TIMSCDR</div>

            <div className="tims-member-toggle-container">
              <div className="tims-toggle-pill">
                <button
                  className={`tims-toggle-btn ${activeTab === 'internal' ? 'active' : ''}`}
                  onClick={() => setActiveTab('internal')}
                >
                  Internal Members
                </button>
                <button
                  className={`tims-toggle-btn ${activeTab === 'external' ? 'active' : ''}`}
                  onClick={() => setActiveTab('external')}
                >
                  External Members
                </button>
              </div>
            </div>

            <div className="tims-p-centered">IIC at TIMSCDR consists of the following members:</div>

            <div className="tims-table-container">
              <table className="tims-data-table">
                <thead>
                  <tr>
                    <th className="tims-th-sr">SR. NO.</th>
                    <th className="tims-th-name">NAME OF MEMBER</th>
                    <th className="tims-th-type">MEMBER TYPE</th>
                    <th className="tims-th-role">KEY ROLE / RESPONSIBILITY</th>
                  </tr>
                </thead>
                <tbody>
                  {memberData[activeTab].map((row, index) => (
                    <tr key={index}>
                      <td className="tims-td-sr">{row[0]}.</td>
                      <td className="tims-td-name tims-font-bold">{row[1]}</td>
                      <td className="tims-td-type">{row[2]}</td>
                      <td className="tims-td-role">{row[3]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Roles Section */}
        <div id="roles" className="tims-section-roles">
          <div className="tims-content-width">
            <div className="tims-section-title">Roles and Responsibilities</div>

            <div className="tims-accordion-container">
              <details className="tims-accordion-item" open>
                <summary className="tims-accordion-header">
                  President
                  <span className="tims-accordion-icon"></span>
                </summary>
                <div className="tims-accordion-content">
                  <ul className="tims-list">
                    <li>He/ She will lead the IIC Council.</li>
                    <li>He/ She will have the IIC portal Login ID and will be the custodian of IIC portal login and data/ reports uploaded therein.</li>
                    <li>He/ She will call the meetings, set meeting agenda and will monitor the deliverable.</li>
                    <li>He/ She will be the main point of contact with MHRD Innovation Cell.</li>
                    <li>He/ She will respond to all communication from IIC National Coordination team (MHRD Innovation Cell) and will be responsible to ensure decent performance of IIC.</li>
                    <li>He/ She will coordinate with the MHRD innovation cell and be responsible for all the IIC activities in the institute.</li>
                    <li>He/ She will ensure Institution's participation in IIC calendar activity and take lead in the institution-driven activities (own initiatives).</li>
                    <li>He/ She will ensure the effective implementation of IIC activities with the help of the Convenor.</li>
                    <li>He/ She could change the council members as per the decision taken in council meetings and update the information on the portal.</li>
                    <li>He/ She will be responsible for submitting the progress/activity reports on the IIC portal.</li>
                  </ul>
                </div>
              </details>

              <details className="tims-accordion-item">
                <summary className="tims-accordion-header">
                  Vice-President
                  <span className="tims-accordion-icon"></span>
                </summary>
                <div className="tims-accordion-content">
                  <ul className="tims-list">
                    <li>To build and strengthen the in-house mentor pool and human resource capacity to drive campus Innovation & Entrepreneurship activities.</li>
                    <li>Identifying, handholding and guiding potential/early-stage entrepreneurs, and student innovators at the Institute on regular basis.</li>
                    <li>To Develop a critical mass of motivated students & faculties with creative potential, and Entrepreneurial orientation & skill set.</li>
                    <li>Commercialization of innovations through technology transfer, technology licensing and Startups, etc.</li>
                    <li>To build infrastructure support and facilities to promote innovation and enable an environment of easy access to resources within and outside the institute.</li>
                    <li>To strengthen the intra and interinstitutional partnership and collaboration with the ecosystem at different level and creation of new program interventions.</li>
                  </ul>
                </div>
              </details>

              <details className="tims-accordion-item">
                <summary className="tims-accordion-header">
                  Convener
                  <span className="tims-accordion-icon"></span>
                </summary>
                <div className="tims-accordion-content">
                  <ul className="tims-list">
                    <li>The Convener will work in close coordination with IIC president and will provide help wherever required for the smooth conduct of activities.</li>
                    <li>He/ She will ensure participation in the meeting and will prepare the meeting agenda at least 10 days prior to meeting with the inputs from all valuable council members and President.</li>
                    <li>Maintain documentation of the proceedings like meeting photos, Minutes of Meetings, Meeting Video has to uploaded to Institution YouTube Channel and the link has to be shared with competent authorities and any other proof.</li>
                    <li>He/ She will ensure that the internal examination dates will not interfere with the IIC activities and coordinate with all departments to ensure the same.</li>
                    <li>He/ She will collect the inputs from all the members of the council at regular intervals, especially external members for better planning of IIC activities and effective delivery of results.</li>
                  </ul>
                </div>
              </details>

              <details className="tims-accordion-item">
                <summary className="tims-accordion-header">
                  Social Media Coordinator
                  <span className="tims-accordion-icon"></span>
                </summary>
                <div className="tims-accordion-content">
                  <ul className="tims-list">
                    <li>Will create and manage IIC page/account on Facebook, Twitter and YouTube and other relevant social media platforms.</li>
                    <li>He / She will be responsible for posting all the relevant information about council meeting resolution and action plan, IIC activities and follow/tag MIC/IIC page and posts on these platforms.</li>
                    <li>He/ She will also ensure that all students follow MIC/IIC page/account on social media to get first-hand information.</li>
                  </ul>
                </div>
              </details>

              <details className="tims-accordion-item">
                <summary className="tims-accordion-header">
                  Members
                  <span className="tims-accordion-icon"></span>
                </summary>
                <div className="tims-accordion-content">
                  <ul className="tims-list">
                    <li>Ensure the Institution's Innovation Council's logo and the words "in association with Institution's Innovation Council, Ministry of Education (MoE), Govt. of India", is included in the brochure compulsorily for all the academic activities of their respective departments like webinars, seminars and workshops related to Industry Interaction, Startup, Entrepreneurship, Research and Innovation / Intellectual Property Rights (IPRs).</li>
                    <li>Establish Innovation Clubs for students with facilities and equipment for Innovation and Entrepreneurship (I & E) activities in their respective departments.</li>
                    <li>Developing an Innovative and Entrepreneurial mindset through workshops, awareness, market outreach events, orientation, advocacy meetings, campus hackathons, and networking events (Intra and Interinstitutional, enablers, stakeholders).</li>
                    <li>Encourage faculty and students to pursue research studies related to Entrepreneurship.</li>
                    <li>Develop short-term certificate courses on Innovation and Entrepreneurship.</li>
                    <li>Convince departments to offer Major or Minor Specializations or credit courses related to Innovation and Entrepreneurship (I & E) and IPR.</li>
                    <li>Organize Employment Generation skill development programs of minimum 30 contact hours of duration.</li>
                    <li>Organize entrepreneurial skill development / employment generating programmes for external participants (local residents, community members, alumni etc.)</li>
                    <li>Coordinate with IPR Cell to generate revenue from patents, copyrights, trade secrets and others.</li>
                    <li>Obtain grants from Government, Non-Govt, CSR Bodies towards promoting and supporting innovations.</li>
                  </ul>
                </div>
              </details>
            </div>
          </div>
        </div>

        {/* Certificates Section */}
        <div id="certificates" className="tims-section-certs">
          <div className="tims-content-width">
            <div className="tims-section-title">IIC Rating & Establishment Certificates</div>
            <div className="tims-cert-gallery-max">
              {["2023-24", "2022-23", "2021-22", "2020-21", "2019-20", "2018-19"].map((year) => (
                <div className="tims-cert-card-max" key={year}>
                  <div className="tims-cert-frame-max">
                    <img
                      src={`/RD/rating-${year}.jpg`}
                      alt={`AY ${year} Rating Certificate`}
                      className="tims-cert-img-max"
                    />
                  </div>
                  <div className="tims-cert-info-max">
                    <div className="tims-cert-name-max">AY {year} Rating Certificate</div>
                    <button
                      className="tims-download-btn-max"
                      onClick={() => handleDownload(year)}
                    >
                      DOWNLOAD
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </>
  );
};

export default IICPage;
